import { Alert, Button, CircularProgress } from "@mui/material";
import { useState } from "react";
import {
  getPlaywrightRunBundleUrl,
  getPlaywrightTestBundleUrl,
} from "./playwright-api";

interface ArtifactDownloadsProps {
  runId: string;
  testKey?: string | null;
  testBundleAvailable?: boolean;
  runBundleAvailable?: boolean;
  getTestUrl?: typeof getPlaywrightTestBundleUrl;
  getRunUrl?: typeof getPlaywrightRunBundleUrl;
  navigate?: (url: string) => void;
}

const ArtifactDownloads = ({
  runId,
  testKey,
  testBundleAvailable = true,
  runBundleAvailable = true,
  getTestUrl = getPlaywrightTestBundleUrl,
  getRunUrl = getPlaywrightRunBundleUrl,
  navigate = (url) => window.location.assign(url),
}: ArtifactDownloadsProps) => {
  const [loading, setLoading] = useState<"test" | "run" | null>(null);
  const [error, setError] = useState("");

  const download = async (target: "test" | "run") => {
    setLoading(target);
    setError("");
    try {
      const url =
        target === "test" && testKey
          ? await getTestUrl(runId, testKey)
          : await getRunUrl(runId);
      navigate(url);
    } catch (nextError: any) {
      setError(
        nextError?.response?.data?.message ||
          nextError?.message ||
          "Unable to prepare artifact download"
      );
    } finally {
      setLoading(null);
    }
  };

  return (
    <div>
      <div className="flex flex-wrap gap-2">
        {testKey && (
          <Button
            variant="outlined"
            disabled={!testBundleAvailable || loading !== null}
            onClick={() => download("test")}
          >
            {loading === "test" && <CircularProgress size={16} sx={{ mr: 1 }} />}
            Download this test
          </Button>
        )}
        {!testKey && (
          <Button
            variant="outlined"
            disabled={!runBundleAvailable || loading !== null}
            onClick={() => download("run")}
          >
            {loading === "run" && <CircularProgress size={16} sx={{ mr: 1 }} />}
            Download full run
          </Button>
        )}
      </div>
      {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
    </div>
  );
};

export default ArtifactDownloads;
